module.exports = __webpack_public_path__ + "img/pic02.7d6d4ef9.png";